<template>
  <IconLucideCircleEqual />
</template>
